
import PropTypes from "prop-types";
import { Typography, TextField } from "@mui/material";
import { useEffect, useRef } from "react";

function PhoneNumber({
  label,
  inputLabel,
  formState,
  setFormState,
  setFormError,
}) {
  function onChange(e) {
    const inputValue = e.target.value;

    const isNumeric = /^\d*$/.test(inputValue);
    if (isNumeric || inputValue === "") {
      setFormState((prev) => ({
        ...prev,
        phoneNumber: inputValue,
      }));
      setFormError(null);
    }
  }
  const inputRef = useRef();

  useEffect(() => {
    inputRef.current?.focus();
  }, []);
  return (
    <>
      <Typography
        id='phoneNumberLabel'
        component='label'
        htmlFor='phoneNumberInput'
        sx={{
          fontWeight: "bold"
        }}
      >
        {label}
      </Typography>
      <TextField
        id='phoneNumberInput'
        margin='dense'
        required
        fullWidth
        inputRef={inputRef}
        label={inputLabel}
        name='phoneNumber'
        onChange={onChange}
        value={formState.phoneNumber || ""}
        inputProps={{ maxLength: 11 }}
      />
    </>
  );
};

const validatePhoneNumber = (phoneNumber) => {
  const regex = /^\d{11}$/;
  console.log("*** validate mobile number ***: ", regex.test(phoneNumber))
  return regex.test(phoneNumber);
};

PhoneNumber.propTypes = {
  label: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  formState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired,
  setFormError: PropTypes.func.isRequired,
};

export { PhoneNumber, validatePhoneNumber };
